import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { CancelCardStackRoutes, CancelCardStackScreenProps } from './type';
import { CancelCardWebZeroScreen } from './CancelCardWebZero.screen';
import { CancelCardNativeZeroScreen } from './CancelCardNativeZero.screen';

export const CancelCardMain: React.FC<CancelCardStackScreenProps<CancelCardStackRoutes.Main>> = ({ navigation, route }) => {
  const { onLayout, onData, account, tab, record, func, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <CancelCardNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        account={account}
        tab={tab}
        record={record}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <CancelCardWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      onData={onData}
      account={account}
      tab={tab}
      record={record}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
    />
  );
};
